$(document).on('click', 'main.profile-admin button.edit, main.profile-admin button.update, main.profile-admin button.cancel', (e) => {
  e.preventDefault();

  $(e.currentTarget)
    .closest('.rows-container')
    .find('.edit-tab, .show-tab')
    .toggleClass('hide');
});